import React, { useEffect, useState } from "react";
import Service from "./Service";
import useTitle from "../../hooks/useTitle";

const Services = () => {
  useTitle("Services")
    const [servicesData,setServicesData]=useState([]);
    useEffect(()=>{
      fetch("services.json")
      .then((res)=>res.json())
      .then((data)=>setServicesData(data))
      .catch((error)=>console.log(error.message))
    },[])
    
  return <div className="bg-[#0E1629] py-20">
    <div className="container">
        <div className='text-center pb-12'>
            <h1 className='text-5xl font-medium text-[#22d3ee]'>Services</h1>
            <p className='text-base mt-1 text-white'>My Services</p>
        </div>
        <div className="grid md:p-0 md:grid-cols-2 lg:grid-cols-3 bg-[#182233] rounded-lg border border-[#2A3343]">
            {
             servicesData && servicesData.map((service)=><Service key={service.id} service={service}></Service>)
            }
        </div>
    </div>
  </div>
};

export default Services;
